// @flow

// NOTE: This Flow module has a corresponding ambient TypeScript declaration in app/types/flow-modules.d.ts. Keep them in sync until this file is migrated to TypeScript.

import type { UserInputValues } from '@tectonics/prs/user-input-values';

export const COLOMBIA_COUNTRY_CODE = '57';

export function isNequiPayment(userInputValues: UserInputValues): boolean {
  return userInputValues['selectedEWallet'] === 'nequi' && userInputValues['selectedPaymentMethod'] === 'ewallet';
}
